// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App'
import router from './router'
import JsonCSV from 'vue-json-csv'
import moment from 'moment'
import VueHtmlToPaper from "vue-html-to-paper";
import wysiwyg from "vue-wysiwyg";
import '@fortawesome/fontawesome-free/css/all.min.css'


import "vue-easytable/libs/theme-default/index.css"; // import style
import VueEasytable from "vue-easytable"; // import library


//import SmartTable from 'vuejs-smart-table'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "vue-wysiwyg/dist/vueWysiwyg.css";
import "@/styles/global.css";

import './plugins/vex'

const VueHtmlToPaper_options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css"
  ]
};




Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueEasytable)
Vue.use(VueHtmlToPaper, VueHtmlToPaper_options)
Vue.use(wysiwyg, {})
//Vue.use(SmartTable)
Vue.component('downloadCsv', JsonCSV)
Vue.directive('uppercase',
  {
    inserted: function(el, _, vnode) {
      el.addEventListener('input', async function(e) {
        e.target.value = e.target.value.toUpperCase()
        vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
      })
    }
  })

Vue.directive('uppercase-nospace',
  {
    inserted: function(el, _, vnode) {
      el.addEventListener('input', async function(e) {
        e.target.value = e.target.value.toUpperCase().replace(" ", "")
        vnode.componentInstance.$emit('input', e.target.value.toUpperCase().replace(" ", ""))
      })
    }
  })





router.beforeEach((to, from, next) => {
  //this bit is there to ensure we protect some routes for authenticated vs non. authenticated users
  const meta = to.meta;
  if ((!meta) || (meta == undefined) || (meta == null) || Object.keys(meta).length == 0){
    next();
  }
  else{
    const is_conditional_route = meta.conditionalRoute;
    if (is_conditional_route == true){
        const stopornot = meta.stopornot();
        if (stopornot == true){
            if (meta.truePath === null){
                next();
            }
            else{
                next({path: meta.truePath});
            }
        }
        else{
            if(meta.falsePath === null){
              next();
            }
            else{
                next({path: meta.falsePath});
            }

        }
    }
  }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js